import { AxiosError } from 'axios';
import instance from '../config/axios';
import { stringify } from 'qs';

export const retryShipment = async (accessToken: string, orderId: number) => {
  try {
    const response = await instance({
      url: `/api/v1/order/retry/shipment?${stringify({ orderId })}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status;
  }
};
